import annotations from './modules/annotations';
import auth from './modules/auth';
import counterpoint from './modules/counterpoint';
import document from './modules/document';
import general from './modules/general';
import geometries from './modules/geometries';
import hover from './modules/hover';
import organization from './modules/organization';
import outline from './modules/outline';
import team from './modules/team';
import user from './modules/user';
import share from './modules/share';
import status from './modules/status';
import logger from './modules/logger';

export default {
  ...annotations.getters,
  ...auth.getters,
  ...counterpoint.getters,
  ...document.getters,
  ...general.getters,
  ...geometries.getters,
  ...hover.getters,
  ...organization.getters,
  ...outline.getters,
  ...team.getters,
  ...user.getters,
  ...share.getters,
  ...status.getters,
  ...logger.getters,
};
